/* eslint-disable camelcase */

import { AxiosRequestConfig, AxiosResponse } from "axios";
import { axiosInst } from "./axiosHVS";

export async function uploadAttachment(
  form: FormData,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<{ data: { attachment_id: string } }>> {
  const result = await axiosInst.post("/attachments/upload", form, config);
  return result;
}

export async function deleteAttachment(id: string): Promise<AxiosResponse> {
  const result = await axiosInst.delete(`/attachments/${id}`);
  return result;
}
